import {todayPeriod} from 'core/Period';
import {valueOf} from 'core/Budget';
import {addedWithinPeriod, spentWithinPeriod} from 'core/History';
import {saved as savedTillToday, perDay as perDayAmount} from 'core/LifeCycle';

export function calcDailyBudget(budget: Budget, history: HistoryLog): DailyBudget {
  const total = valueOf(budget);
  const today = todayPeriod();

  const perDay = perDayAmount(budget);
  const spent = spentWithinPeriod(history, today);
  const added = addedWithinPeriod(history, today);
  const saved = savedTillToday(budget, history);

  return {
    amount: Math.min(Math.max(perDay + saved - spent, 0), total),
    perDay,
    spent,
    saved,
    added,
  };
}
